import { FC, Fragment } from 'react'
import { Row, Text, Image, Col, List, ListItem } from '@/client/components'
import * as S from './styles'
import { FooterWindmillProps } from '../types'

export const FooterWindmill: FC<FooterWindmillProps> = ({
  footer_heading,
  footer_long_text,
  fsc_icon,
  windmill,
  green_box,
  milestone,
  milestone_list
}) => {
  const directions = [
    { dir: 'column', mq: 'sm' },
    { dir: 'row', mq: 'hd' }
  ]

  return (
    <>
      <Row>
        <S.HeaderSection>
          <S.Sections>
            <Text size='xxlg' weight='semiBlack' lineHeight='1.2'>
              <span dangerouslySetInnerHTML={{ __html: footer_heading }} />
            </Text>
          </S.Sections>
          <S.Sections>
            <Text lineHeight='1.3' color='black' size='md' margin='0 1rem 0 0'>
              {footer_long_text}
            </Text>
          </S.Sections>
          <S.IconWrapper>
            <Text margin='0.15rem'>
              <span dangerouslySetInnerHTML={{ __html: fsc_icon }} />
            </Text>
          </S.IconWrapper>
        </S.HeaderSection>
      </Row>
      <Row directions={directions}>
        <Col style={{ paddingRight: '0' }}>
          <div style={{ overflow: 'hidden' }}>
            <Image src={windmill.url} width='700' height='481' />
          </div>
        </Col>
        <Col style={{ paddingLeft: '0' }}>
          <S.Box>
            {green_box.map(({ key, sub_heading, sub_long_text }) => (
              <S.GreenBox key={key}>
                <Fragment key={key}>
                  <Text size='xlg' weight='semiBlack' lineHeight='1.3'>
                    <span dangerouslySetInnerHTML={{ __html: sub_heading }} />
                  </Text>
                  <Text lineHeight='1.3'>{sub_long_text}</Text>
                </Fragment>
              </S.GreenBox>
            ))}
          </S.Box>
          <S.Box>
            <S.Milestones>
              <Text size='xlg' weight='semiBlack' lineHeight='1.3' color='inverse' margin='0 0 0.5rem'>
                {milestone}
              </Text>

              <List>
                {milestone_list.map(({ key, text }) => (
                  <ListItem key={key} iconName='tick-and-circle' iconSize='s4' fontSize='small'>
                    {text}
                  </ListItem>
                ))}
              </List>
            </S.Milestones>
          </S.Box>
        </Col>
      </Row>
    </>
  )
}
